import { Grid, Box, Button } from '@mui/material';
import { BasicCard } from "../../shared/basicCard";
import { MemberSummary } from "../../api/models/member";


export interface SelectMemberSummaryPanelProps {
    member: MemberSummary;
    onSelected: (memberGuid: string) => void;
}

export function SelectMemberSummaryPanel(props: SelectMemberSummaryPanelProps) {

    return (<>
        <Grid container spacing={3} alignItems="center">
        </Grid>
        <BasicCard>
                <img src={props.member.profileLink} height={100} alt='logo' style={{ border: '1px solid #909090' }} />
                <br />
                <Box>{props.member.firstName} {props.member.lastName}</Box>
                <br />
                <span style={{ fontSize: '12px' }}>Jersey Number: {props.member.jerseyNumber}</span>
                <br />
            
             <Button onClick={e => props.onSelected(props.member.id)} variant="contained" color="primary">
                Select
             </Button>
        </BasicCard>
    </>
    );
}